const ActiveItemReturnIdentityButton = ({icon, text, returnIdentity}) => {
  return (
    <button
        className="card-details__button card-details__button--craft"
        onClick={returnIdentity}
      >
        <img src={icon} alt="" />
        {text}
      </button>
  )
}

export default ActiveItemReturnIdentityButton
